import { useNavigate } from 'react-router';
import { FormikProps } from 'formik';
import { FormikForm } from '@/components/form/FormikForm/FormikForm';
import { FormikPasswordInput } from '@/components/form/fields/FormikPasswordInput/FormikPasswordInput';
import { BulletValidation } from '@/bundle/Auth/InviteUserFlow/SetInitialPasswordPage/ui/BulletValidation/BulletValidation';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { validatePassword } from '@/bundle/Auth/const/const';
import { ResponseErrorType } from '@/types/sharedTypes';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';

type FormikPropsType = {
  password: string;
  passwordConfirmation: string;
};

type SetPasswordFormType = {
  formik: FormikProps<FormikPropsType>;
  apiError: ResponseErrorType;
  isLoading: boolean;
};

export const SetPasswordForm = ({ formik, apiError, isLoading }: SetPasswordFormType) => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate(getLoginPath());
  };

  const { isValid } = validatePassword(formik.values?.password);
  const isTouchedPasswordField = formik.touched.password;
  const isFormValid = isValid && formik.isValid;

  return (
    <FormikForm value={formik}>
      <FormikPasswordInput
        label='New Password*'
        placeholder='Enter Your New Password'
        name='password'
        apiError={apiError}
        maxLength={30}
        hasToggleEye
        autoComplete='new-password'
      />
      <BulletValidation password={formik?.values?.password} isTouchedPasswordField={isTouchedPasswordField} />
      <FormikPasswordInput
        label='Confirm New Password*'
        placeholder='Confirm Your Password'
        name='passwordConfirmation'
        apiError={apiError}
        maxLength={30}
        isCopyPasteDisabled
        isConfirmTicks
        hasToggleEye
        autoComplete='new-password'
      />
      <Box display='flex' flexDirection='column' rowGap='12px' marginTop='12px'>
        <Button isLoading={isLoading} type='submit' disabled={!isFormValid}>
          Submit
        </Button>
        <Button variant='secondary' onClick={navigateToLogin}>
          Return to Login
        </Button>
      </Box>
    </FormikForm>
  );
};
